import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import StoreFeedCard from '../../components/StoreFeedCard'
import Loader from '../../components/Loader'
import { api } from '../../app/Api/ApiSlice'

import './storesStyles.css'
import { FaSearch } from 'react-icons/fa'

const Stores = () => {
    const [stores, setStores] = useState({})
    const [isLoading, setIsLoading] = useState(false)


    useEffect(() => {
        fetchStores()
    }, [])

    const fetchStores = async () => {
        if (isLoading) return

        try {
            setIsLoading(true)

            const response = await api.get('/stores')

            const data =
                response?.data &&
                    typeof response.data === 'object' &&
                    !Array.isArray(response.data)
                    ? response.data
                    : {}

            setStores(data)
        } catch (error) {
            toast.error(
                error?.response?.data?.message || 'Failed to load stores'
            )
            setStores({})
        } finally {
            setIsLoading(false)
        }
    }

    const hasStores = Object.values(stores).some(
        list => Array.isArray(list) && list.length > 0
    )

    return (
        <div className="store-feeds page-body">
            <div className="stores-page-content">
                <div className="stores-page-header">
                    <h2 className="stores-page-title">Businesses</h2>
                    <div className="store-search-btn">
                        <Link to={"/b/search"}><FaSearch /></Link>
                    </div>
                    <Link to="/b/create">
                        <p>Create</p>
                    </Link>
                </div>

                {isLoading && <Loader />}

                {!isLoading && !hasStores && (
                    <p className="empty-state">No businesses available</p>
                )}
                {isLoading && <Loader />}

                <div className="stores-grid">
                    {Object.entries(stores).map(([category, list]) => {
                        if (!Array.isArray(list) || list.length === 0)
                            return null

                        return (
                            <div
                                className="stores-category"
                                key={category}
                            >
                                <div className="stores-category-header">
                                    <h2>{category}</h2>
                                </div>

                                <div className="category-stores-scroll">
                                    {list.map(store =>
                                        store?._id ? (
                                            <StoreFeedCard
                                                key={store._id}
                                                str={store}
                                            />
                                        ) : null
                                    )}
                                </div>

                                <div className="see-more">
                                    <Link
                                        to={
                                            category === 'mystores'
                                                ? '/b/mystores'
                                                : category === 'favourites'
                                                    ? '/b/favourites'
                                                    : `/b/category/${category}`
                                        }
                                    >
                                        <button>See More</button>
                                    </Link>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default Stores
